import { render, staticRenderFns } from "./speedchat-message.vue?vue&type=template&id=65ad3cfc&scoped=true&lang=pug&"
import script from "./speedchat-message.vue?vue&type=script&lang=js&"
export * from "./speedchat-message.vue?vue&type=script&lang=js&"
import style0 from "./speedchat-message.vue?vue&type=style&index=0&id=65ad3cfc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65ad3cfc",
  null
  
)

export default component.exports